/* eslint-disable max-lines */
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { UlItem } from '@com-delta-idp/mnx-ui-kit';
import {
  AddSqaContent,
  AddSqaErrorMessages,
  AddSqaFormAttributes,
  AddSqaPageContent,
  Error,
  ErrorOption,
  SecurityQuestionContentApi,
  SecurityQuestionsContent
} from '../modals/add-sqa.interface';

const securityQuestionList: UlItem[] = [
  {
    type: 'Y',
    id: '1',
    label: 'What is the name of the first school you attended?'
  },
  {
    type: 'Y',
    id: '2',
    label: 'What is the name of your first pet?'
  },
  {
    type: 'Y',
    id: '4',
    label: "What is your father's middle name?"
  },
  {
    type: 'Y',
    id: '5',
    label: "What is your paternal grandmother's given name?"
  },
  {
    type: 'Y',
    id: '6',
    label: 'What is the phone number you remember most from your childhood?'
  },
  {
    type: 'Y',
    id: '7',
    label: 'What was your favorite place to visit as a child?'
  },
  {
    type: 'Y',
    id: '8',
    label: 'What is the name of your childhood best friend?'
  },
  {
    type: 'Y',
    id: '9',
    label: 'Where did you meet your spouse/partner?'
  },
  {
    type: 'Y',
    id: '10',
    label: 'What city is your ultimate dream destination?'
  },
  {
    type: 'Y',
    id: '11',
    label: "What is one travel item you can't do without?"
  },
  {
    type: 'Y',
    id: '12',
    label: "What is the most distant city you've ever visited?"
  }
];

export const securityQuestionsMock: SecurityQuestionsContent = {
  securityQuestionList: securityQuestionList
};

export const securityQuestionsApiMock: SecurityQuestionContentApi = {
  securityQuestionList: [
    {
      currentIndicator: 'Y',
      questionNumber: '1',
      questionText: 'What is the name of the first school you attended?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '2',
      questionText: 'What is the name of your first pet?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '4',
      questionText: "What is your father's middle name?"
    },
    {
      currentIndicator: 'Y',
      questionNumber: '5',
      questionText: "What is your paternal grandmother's given name?"
    },
    {
      currentIndicator: 'Y',
      questionNumber: '6',
      questionText:
        'What is the phone number you remember most from your childhood?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '7',
      questionText: 'What was your favorite place to visit as a child?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '8',
      questionText: 'What is the name of your childhood best friend?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '9',
      questionText: 'Where did you meet your spouse/partner?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '10',
      questionText: 'What city is your ultimate dream destination?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '11',
      questionText: "What is one travel item you can't do without?"
    },
    {
      currentIndicator: 'Y',
      questionNumber: '12',
      questionText: "What is the most distant city you've ever visited?"
    },
    {
      currentIndicator: 'Y',
      questionNumber: '13',
      questionText: 'What is your favorite summer vacation activity?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '14',
      questionText: 'What city is your favorite winter vacation spot?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '15',
      questionText: 'Where is the first place you ever flew?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '16',
      questionText: 'What year did you take your first flight?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '17',
      questionText:
        "What is the strangest food you've ever eaten while traveling?"
    },
    {
      currentIndicator: 'Y',
      questionNumber: '18',
      questionText: 'What is your favorite foreign city?'
    },
    {
      currentIndicator: 'Y',
      questionNumber: '19',
      questionText: "What is the coolest landmark you've ever visited?"
    }
  ]
};

const formAttributesMock: AddSqaFormAttributes = {
  errorCount: 0,
  submitAttempt: false,
  errorAlertBanner: false,
  answerOneControlTouched: false,
  answerTwoControlTouched: false,
  questionOneControlTouched: false,
  questionTwoControlTouched: false,
  disableActionButton: false
};

const pageContentMock: AddSqaPageContent = {
  answer1Label: 'Answer 1',
  answer1Text: '',
  answer2Label: 'Answer 2',
  answer2Text: '',
  buttonLabel: 'Continue',
  contentBodyHeader:
    'We do not have security questions associated with your account. You must establish security questions and answer to continue.',
  defaultSelectValue: 'Select One',
  errors: {
    alertWarning: 'To continue, please correct the',
    answerOneErrorMessage: {
      INVALID_FIRST_SEC_ANS:
        'Whoops! Please enter a valid answer for the first question.',
      ANS_IN_USE:
        'We are sorry, it looks like you are already using this answer. Please provide a unique answer for each question.',
      SEC_ANS_LESS_THAN_FOUR_CHAR:
        'Your security answers must contain at least four characters. Please try again.'
    },
    answerTwoErrorMessage: {
      INVALID_SECOND_SEC_ANS:
        'Whoops! Please enter a valid answer for the second question.',
      ANS_IN_USE:
        'We are sorry, it looks like you are already using this answer. Please provide a unique answer for each question.',
      SEC_ANS_LESS_THAN_FOUR_CHAR:
        'Your security answers must contain at least four characters. Please try again.'
    },
    questionOneErrorMessage: {
      SEL_FIRST_SEC_QUESTION:
        'Whoops! Please select your first security question to continue.'
    },
    questionTwoErrorMessage: {
      SEL_SECOND_SEC_QUESTION:
        'Whoops! Please select your second security question to continue.',
      QUESTION_IN_USE:
        'Oops! We are sorry, it looks like you are already using this question. Please select unique questions.'
    }
  },
  headerSubTitle: '*fields required',
  headerTitle: 'Add Security Questions',
  nextDisplayView: {
    button_continue: '',
    button_createPassword: '',
    button_forgotPassword: '',
    button_loginHelp: '',
    button_modal: 'Continue',
    button_resetPassword: '',
    button_sendLogin: '',
    button_wfp: '',
    nextViewName: 'setPassword',
    nextViewName_createPassword: '',
    nextViewName_email: '',
    nextViewName_forgotPassword: '',
    nextViewName_loginHelp: '',
    nextViewName_resetPassword: '',
    nextViewName_sendLogin: '',
    nextViewName_sqa: '',
    overlayMessage: '',
    refreshUrl: ''
  },
  pageHeader: {
    headerSubTitle: '*fields required',
    headerTitle: 'Add Security Questions',
    altText: 'logo',
    logoUrl:
      'https://st.delta.com/content/dam/delta-www/responsive/apps/login/supergraphic-delta.png'
  },
  question1Label: 'Question 1',
  question2Label: 'Question 2',
  viewName: 'securityQuestionAnswers',
  securityQuestionList: securityQuestionList
};

export const addSqaFormGroupMock: UntypedFormGroup = new UntypedFormGroup({
  questionOne: new UntypedFormControl(null, [Validators.required]),
  questionTwo: new UntypedFormControl(null, [Validators.required]),
  answerOne: new UntypedFormControl(null, [Validators.required]),
  answerTwo: new UntypedFormControl(null, [Validators.required])
});

export const addSqaContentMock: AddSqaContent = {
  formGroup: addSqaFormGroupMock,
  formAttributes: formAttributesMock,
  pageContent: pageContentMock,
  hasError: false,
  errorMessage: ''
};

export default addSqaContentMock;

export const mockErrors: Error[] = [{ code: '21', description: 'description' }];

export const mockErrorMessageOption: ErrorOption = {
  errorId: '',
  errorMessageDescription: 'Test Error',
  errorMessageTitle: ''
};

export const mockAddSqaErrorMessages: AddSqaErrorMessages = {
  answerOneErrorMessage: {
    INVALID_FIRST_SEC_ANS: '',
    ANS_IN_USE: '',
    SEC_ANS_LESS_THAN_FOUR_CHAR: ''
  },
  answerTwoErrorMessage: {
    INVALID_SECOND_SEC_ANS: '',
    ANS_IN_USE: '',
    SEC_ANS_LESS_THAN_FOUR_CHAR: ''
  },
  questionOneErrorMessage: {
    SEL_FIRST_SEC_QUESTION: ''
  },
  questionTwoErrorMessage: {
    SEL_SECOND_SEC_QUESTION: '',
    QUESTION_IN_USE: ''
  },
  alertWarning: ''
};

export const mockAddSqaRequestObj = {
  securityQuestionNbr1: '1',
  securityQuestionNbr2: '2',
  tlMaskInfo_answer1: 'Ans1',
  tlMaskInfo_answer2: 'Ans2'
};

export const mockEnteredFormValue = {
  questionOne: {
    id: 'questionOne',
    value: '1',
    label: 'What is the name of the first school you attended?'
  },
  questionTwo: {
    id: 'questionTwo',
    value: '2',
    label: 'What is the name of your first pet?'
  },
  answerOne: { id: 'answerOne', value: 'Ans1' },
  answerTwo: { id: 'answerTwo', value: 'Ans2' }
};

export const mockResponseAddSqa = {
  firstName: 'Test',
  lastName: 'Eightx',
  skymilesBalance: '0',
  refreshURL: 'https//dvl2.delta.com/',
  formNameSubmitted: 'login',
  isLoggedIn: true,
  hasSQA: true,
  hasEmail: true,
  isEmailValid: true,
  smNbr: '9617821161',
  smType: 'BaseSm',
  loginMethod: 'Skymiles',
  rememberMe: 'false',
  isBusiness: false
};

export const mockErrorResponseAddSqa = {
  firstName: 'Test',
  lastName: 'Eightx',
  skymilesBalance: '0',
  refreshURL: 'https//dvl2.delta.com/',
  formNameSubmitted: 'login',
  isLoggedIn: true,
  hasSQA: true,
  hasEmail: true,
  isEmailValid: true,
  smNbr: '9617821161',
  smType: 'BaseSm',
  loginMethod: 'Skymiles',
  rememberMe: 'false',
  isBusiness: false,
  errors: [
    {
      code: '21',
      description: 'some error'
    }
  ]
};
